import { EPromoCode } from "@interfaces/promoCode.enum";
import { authApi } from "@RTKQuery/basic";

const promoCodesAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        checkingPromoCode: build.mutation<
            { type: EPromoCode, bonus: number } ,
            { promo_code: string }
        >({
            query: (params) => ({
                url: "promo_codes",
                method: "GET",
                params
            }),
        })
    }),
    overrideExisting: false,
})

export const {
    useCheckingPromoCodeMutation
} = promoCodesAuthApi;